import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["flyout", "backdrop", "panel"]

  connect() {
    if (this.hasFlyoutTarget) {
      this.hideElements()
      // Closes flyout on submit-end if there's a form present that's turbo-enabled.
      this.element.addEventListener("turbo:submit-end", this.closeOnSuccess)
    }
  }

  open(event) {
    event.stopPropagation()
    this.toggleClasses(true)
  }

  close() {
    this.toggleClasses(false)
    setTimeout(() => this.backdropTarget.classList.add("hidden"), 200)
  }

  toggle(event) {
    event.stopPropagation()
    this.flyoutTarget.classList.contains("translate-x-full")
      ? this.open(event)
      : this.close()
  }

  closeIfOutside(event) {
    if (
      !this.panelTarget.contains(event.target) &&
      !this.flyoutTarget.classList.contains("translate-x-full")
    ) {
      this.close()
    }
  }

  hideElements() {
    this.flyoutTarget.classList.add("translate-x-full")
    this.backdropTarget.classList.add("hidden", "opacity-0")
  }

  closeOnSuccess = ({ detail: { success } }) => {
    if (success) this.close()
  }

  toggleClasses(isOpen) {
    this.flyoutTarget.classList.toggle("translate-x-full", !isOpen)
    this.flyoutTarget.classList.toggle("translate-x-0", isOpen)
    this.backdropTarget.classList.toggle("hidden", !isOpen)
    this.backdropTarget.classList.toggle("opacity-0", !isOpen)
    this.backdropTarget.classList.toggle("opacity-70", isOpen)
  }
}
